export default __webpack_public_path__ + "static/media/btn-send.e543decb.svg";